import React, { useState } from 'react'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'
import * as Yup from 'yup';
import { useFormik } from "formik";
import axios from 'axios';
import { BASE_URL } from '../../routes/config';
import { Message } from '@mui/icons-material';
import { colors } from '@mui/material';

const initialValues = {
  name_field: '',
  email_field: '',
  mobile_field: '',
  department_field: '',
  subject_field: '',
  comment_field: '',
  // file_field: null,
  // token: '',
};

const validationSchema = Yup.object({
  name_field: Yup.string().required('Please enter your Name'),
  email_field: Yup.string().email('Invalid email format').required('Please enter your Email'),
  mobile_field: Yup.string().required('Please enter your Mobile Number'),
  department_field: Yup.string().required('Please select a Department'),
  subject_field: Yup.string().required('Please enter Subject'),
  comment_field: Yup.string().required('Please enter Comment'),
  // file_field: Yup.string().required('Please Attached Attach File'),
});

function GrievancePage() {
  const [currentTime, setCurrentTime] = useState('');


  const generateToken = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const dd = String(now.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const onSubmit = (values) => {
    const newCurrentTime = generateToken();
    setCurrentTime(newCurrentTime);
    console.log(values, 'Submitted Grievance', currentTime);
    // setFormValues({ ...values, token: newToken });
    fetchdata(values, currentTime)
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true,
    validateOnMount: true,
  });


  const fetchdata = async (value, currentTime) => {
    // setLoading(true);

    const formData = new FormData();

    // // Append each field to FormData

    formData.append("name", formik.values.name_field);
    formData.append("email", formik.values.email_field);
    formData.append("upl_file", formik.values.file_field);
    formData.append("ph_no", formik.values.mobile_field);
    formData.append("department", formik.values.department_field);
    formData.append("subject", formik.values.subject_field);
    formData.append("comments", formik.values.comment_field);
    formData.append("created_at", currentTime);


    try {
      const response = await axios.post(
        `${BASE_URL}/wapi/grievance`,
        formData,
        {
        auth_key: "xxxxx",
      }
        // {
        //   headers: {
        //     Authorization: loginData.token,
        //   },
        // }
      );

      // Message("success", "Updated successfully.");
      formik.resetForm();
      formData.append("upl_file", '');
    } catch (error) {
      // setLoading(false);
      // Message("error", "Error Submitting Form:");
      console.error("Error submitting form:", error);
    }

  }

  return (
    <>
      <div className="wrapper">
        <div className="inner_page_Sec">
          <div className="col-sm-8 float-left left_sec searchPageTop">
            <h1>Grievance</h1>

            <div className="form_grievance">

              <div className='txt_box_grev'>For Grievances related to Administrative issues ,  
                You may contact <strong>Shri Suman Chakraborty, Deputy Manager</strong> <br /> 
                <strong>Phone Number:</strong> 9674746915  <strong>Email Id:</strong> <a href="mailto:sumanbenfed@gmail.com">sumanbenfed@gmail.com</a></div>

              <div className='txt_box_grev'>For Grievances related to Business issues , 
                You may contact <strong>Shri Santanu Pandit, Manager (Marketing)</strong> <br /> 
                <strong>Phone Number:</strong> 9674746921  <strong>Email Id:</strong>  <a href="mailto:managermarketing@benfed.org">managermarketing@benfed.org</a></div>



              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-6">
                    <label className="form-label">Name</label>
                    <input
                      className="form-control"
                      name="name_field"
                      type="text"
                      placeholder="Name..."
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name_field}
                    />
                    {formik.touched.name_field && formik.errors.name_field && (
                      <div className="required_greviewnce">{formik.errors.name_field}</div>
                    )}
                  </div>

                  <div className="col-lg-6">
                    <label className="form-label">Email Address</label>
                    <input
                      className="form-control"
                      name="email_field"
                      type="text"
                      placeholder="Email Address..."
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.email_field}
                    />
                    {formik.touched.email_field && formik.errors.email_field && (
                      <div className="required_greviewnce">{formik.errors.email_field}</div>
                    )}
                  </div>

                  <div className="col-lg-6">
                    <label className="form-label">Mobile Number</label>
                    <input
                      className="form-control"
                      name="mobile_field"
                      type="text"
                      placeholder="Mobile No..."
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.mobile_field}
                    />
                    {formik.touched.mobile_field && formik.errors.mobile_field && (
                      <div className="required_greviewnce">{formik.errors.mobile_field}</div>
                    )}
                  </div>

                  <div className="col-lg-6">
                    <label className="form-label">Department</label>
                    <select
                      className="form-control"
                      name="department_field"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.department_field}
                    >
                      <option value="">Select Department</option>
                      <option value="Agri Input/Fertilizer">Agri Input/Fertilizer</option>
                      <option value="Agri Marketing / Procurement">Agri Marketing / Procurement</option>
                      <option value="Accounting">Accounting</option>
                      <option value="Warehouse">Warehouse</option>
                      <option value="Engineering">Engineering</option>
                    </select>
                    {formik.touched.department_field && formik.errors.department_field && (
                      <div className="required_greviewnce">{formik.errors.department_field}</div>
                    )}
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label">Subject</label>
                    <input
                      className="form-control"
                      name="subject_field"
                      type="text"
                      placeholder="Subject..."
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.subject_field}
                    />
                    {formik.touched.subject_field && formik.errors.subject_field && (
                      <div className="required_greviewnce">{formik.errors.subject_field}</div>
                    )}
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label">Your Comment</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      name="comment_field"
                      placeholder="Your Comment..."
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.comment_field}
                    ></textarea>
                    {formik.errors.comment_field && formik.touched.comment_field && (
                      <div className="required_greviewnce">{formik.errors.comment_field}</div>
                    )}
                  </div>

                  <div className="col-lg-12">
                    <label className="form-label">Attach File (.pdf / .jpeg / .png)</label>
                    <input
                      className="form-control"
                      type="file"
                      name="file_field"
                      accept=".pdf, .jpeg, .jpg, .png"
                      onChange={(event) => {
                        formik.setFieldValue("file_field", event.currentTarget.files[0]);
                      }}
                    />
                  </div>

                  <div className="col-lg-12 mt-3">
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>

                  {/* {token && (
                    <div className="col-lg-12 mt-3">
                      <strong>Grievance Token:</strong> {token}
                    </div>
                  )} */}
                </div>
              </form>
            </div>
          </div>

          <div className="col-sm-4 float-left">
            <RightSidebarGlobal />
          </div>
        </div>
      </div>
    </>
  );
}

export default GrievancePage;
